import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { DataConfirm } from './confirm.service';

@Component({
    selector: 'confirm',
    styleUrls: ['./confirm.component.scss'],
    template: `
    <h1 matDialogTitle class="mb-8">{{ data.title }}</h1>
    <div mat-dialog-content class="mb-16" [innerHTML]="data.message"></div>
    <div mat-dialog-actions>
      @if (data.buttonCancel.show) {
        <button
          color="accent"
          mat-dialog-close
          mat-raised-button
          type="button"
          (click)="dialogRef.close(false)"
          >
          {{ data.buttonCancel.label }}
        </button>
      }
      @if (data.buttonConfirm.show) {
        <button
          mat-raised-button
          type="submit"
          color="primary"
          (click)="dialogRef.close(true)"
          >
          {{ data.buttonConfirm.label }}
        </button>
      }
    </div>
    `,
    standalone: false
})
export class ConfirmComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataConfirm,
  ) {
  }
}
